/** Wording for how far an invoice is from (or past) its due date, shared by the list rows. */

const DAY_MS = 86_400_000;

/** Whole days from `today` to `dueDate` (both YYYY-MM-DD, compared as calendar dates so DST cannot shift the count). */
export function daysBetween(today: string, dueDate: string): number {
  return Math.round((Date.parse(`${dueDate}T00:00:00Z`) - Date.parse(`${today}T00:00:00Z`)) / DAY_MS);
}

/**
 * Returns e.g. "9 days overdue", "Due today", "Due in 4 days", or null when there is nothing to say
 * (no due date, or the invoice is settled, void or still a draft).
 */
export function invoiceDueLabel(
  invoice: { status: string; dueDate?: string | null },
  today: string,
): string | null {
  if (!invoice.dueDate) return null;
  if (!['sent', 'approved', 'overdue'].includes(invoice.status)) return null;
  const days = daysBetween(today, invoice.dueDate.slice(0, 10));
  if (Number.isNaN(days)) return null;
  // A manually set 'overdue' status with a future date is contradictory; say nothing rather than disagree with the badge.
  if (invoice.status === 'overdue' && days >= 0) return null;
  if (days < 0) return `${-days} ${days === -1 ? 'day' : 'days'} overdue`;
  if (days === 0) return 'Due today';
  return `Due in ${days} ${days === 1 ? 'day' : 'days'}`;
}
